export enum EntityType {
  MARKET_INSIGHT = "market_insight",
  OPPORTUNITY = "opportunity",
  SOLUTION = "solution",
  STARTUP = "startup",
  PROJECT = "project",
  COMMITTEE = "committee",
  ENTREPRENEUR = "entrepreneur",
  APPLICATION = "application",
}

export enum SearchContext {
  TERMINUS = "terminus",
  FOUNDERSHUB = "foundershub",
}

export interface SearchResult {
  id: string;
  entity_type: EntityType;
  title: string;
  subtitle: string | null;
  status: string | null;
  route: string;
  score: number;
  matched_field: string;
}

export interface SearchResponse {
  query: string;
  results: SearchResult[];
  total_count: number;
  entity_counts: Record<string, number>;
}

export const ENTITY_TYPE_LABELS: Record<EntityType, string> = {
  [EntityType.MARKET_INSIGHT]: "Market Insight",
  [EntityType.OPPORTUNITY]: "Opportunity",
  [EntityType.SOLUTION]: "Solution",
  [EntityType.STARTUP]: "Startup",
  [EntityType.PROJECT]: "Project",
  [EntityType.COMMITTEE]: "Committee",
  [EntityType.ENTREPRENEUR]: "Entrepreneur",
  [EntityType.APPLICATION]: "Application",
};

export const TERMINUS_ENTITY_TYPE_SHORTCUTS: Record<string, EntityType[]> = {
  market: [EntityType.MARKET_INSIGHT],
  mi: [EntityType.MARKET_INSIGHT],
  opp: [EntityType.OPPORTUNITY],
  opportunity: [EntityType.OPPORTUNITY],
  hyp: [EntityType.SOLUTION],
  solution: [EntityType.SOLUTION],
  startup: [EntityType.STARTUP],
  s: [EntityType.STARTUP],
  project: [EntityType.PROJECT],
  p: [EntityType.PROJECT],
  committee: [EntityType.COMMITTEE],
  c: [EntityType.COMMITTEE],
};

export const FOUNDERSHUB_ENTITY_TYPE_SHORTCUTS: Record<string, EntityType[]> = {
  entrepreneur: [EntityType.ENTREPRENEUR],
  ent: [EntityType.ENTREPRENEUR],
  founder: [EntityType.ENTREPRENEUR],
  application: [EntityType.APPLICATION],
  app: [EntityType.APPLICATION],
  a: [EntityType.APPLICATION],
};

export const ENTITY_TYPE_SHORTCUTS: Record<string, EntityType[]> = {
  ...TERMINUS_ENTITY_TYPE_SHORTCUTS,
  ...FOUNDERSHUB_ENTITY_TYPE_SHORTCUTS,
};
